module.exports = new __parcel__URL__("reward_claim_button.dd21c4c6.png").toString();